function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import * as React from 'react';
import { logClientError } from '../utils/appUtils';
class SpzaComponent extends React.Component {
    renderImpl() {
        // should never be called
        throw new Error('SpzaComponent renderImpl method should never be called!\nMake sure you are implementing renderImpl in your Component');
    }
    renderFailImpl(err) {
        // rendering must _never_ let an error escape. This puts react in a bad state and
        // current versions (15.x) cannot deal with that.
        logClientError(err, 'client side error: [From spzaComponent] ');
        // no longer we render the error modal from here the main client hook up handles all errors.
        throw err;
    }
    render() {
        try {
            return this.renderImpl();
        } catch (err) {
            return this.renderFailImpl(err);
        }
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { SpzaComponent as default };
